import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendSelectClickSoundCommand } from '../../helpers/web_to_client'

import styles from './RadioButton.css'

const propTypes = {
    name: PropTypes.string.isRequired,
    caption: PropTypes.node,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    tooltipId: PropTypes.string,
}

const defaultProps = {
    isChecked: false,
}

class RadioButton extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange() {
        if (!this.props.isDisabled) {
            sendSelectClickSoundCommand()
            this.props.onChange()
        }
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isChecked]: this.props.isChecked,
            [styles.isDisabled]: this.props.isDisabled,
            [styles.hasCaption]: this.props.caption,
        })

        const caption = this.props.caption ? (
            <span className={styles.caption}>{this.props.caption}</span>
        ) : null

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <label
                className={classNameBase}
                onMouseEnter={this.props.isDisabled ? null : sendHoverSoundCommand}
                {...dataAttrs}
            >
                <input
                    type="radio"
                    name={this.props.name}
                    className={styles.input}
                    checked={this.props.isChecked}
                    onChange={this.handleChange}
                />
                <span className={styles.check} />
                {caption}
            </label>
        )
    }
}

RadioButton.propTypes = propTypes
RadioButton.defaultProps = defaultProps

export default RadioButton



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/RadioButton/RadioButton.jsx